import { useBadgeTemplatePreview } from '../../../../ui/features/badge-preview/hooks/useBadgeTemplatePreview';
import React from 'react';
import { BadgePreview } from '.';
/**
 * Component that renders non-compiled template to the DOM
 *
 * * to render compiled template use {@link BadgePreview}
 */
export const BadgeTemplatePreview = ({ badgeTemplate, badgeTemplateClassifier, formSettings, account, sx, }) => {
    const compiledTemplate = useBadgeTemplatePreview({
        badgeTemplate,
        badgeTemplateClassifier,
        formSettings,
        account,
    });
    return React.createElement(BadgePreview, { badgeTemplate: compiledTemplate, sx: sx });
};
